import {IAnalyticsData} from '../services/analytics/analytics_service_interface';
import {IJackpotDataByGame, IJackpotDataById} from '../services/live_feeds/jackpots/jackpot_feeds_service_interface';
/* eslint-enable no-unused-vars */
import _Logger from '../utils/logger';
import Initialize from './initialize';
import {SYSTEM_EVENTS} from '../events/events';
import Event from '../utils/event';
import {SDK_VERSION} from '../sdk-version';
/*
 we can't use ServiceFactory instead of ConfigService
 because ConfigService is used in the initialize()
 */
import ConfigService from '../services/config/config_service';
import OptionsComponentController from '../components/options/options_component_controller';
import _ from '../utils/underscore';
import Device from '../utils/device/device';
import ServiceFactory from '../services/service_factory';
import Directive from './directive';
import {IAutoLoginParams} from '../../../common/interfaces/autologin-params.interface';
import {BalanceType} from '../../../common/const/wallet_balance_type';
import IStructuredLoggingService from "../../../common/interfaces/structured-logging-service-interface";
import {SdkOverlayZIndex} from "../../../common/interfaces/sdk-overlay-z-index";
import {PRIORITY_LEVEL, PRIORITY_LEVEL_ZINDEX_MAPPER} from "../services/overlay_manager/overlay_manager_levels";
import {IGeoLocationInfo} from "../../../common/interfaces/geo-location-info.interface";
import {IScriptLoaderService} from "../../../app-react/services/scrip-loader/script-loader.service.interface";
import {Check, TimeSpan} from "@sparkware/app-utils";
import {MarketingParams} from "../../../common/interfaces/marketing-params.interface";
import {IAbTestingFeatureProperties} from "../../../common/interfaces/ab-testing-interface";
import DOM from "../utils/dom";
import {GNWP_SOURCES} from "../../../app-react/services/gnwp/gnwp-consts";
import {IDateFormattedToRegulationOffset} from '../../../app-react/services/sdk/cgp-sdk.interface';
import {LoadScriptOptions} from "../../../common/interfaces/load-script-options";
import {NullableString} from "../../../common/types/nullable-types";
import {IGameRestriction} from "../../../app-react/services/restrictions/game-restriction.interface";



const Logger = new _Logger('API');

/**
 * API class handle of the application initialization and it's the only thing
 * That bare to the client.
 *
 * Usage:
 *
 * When we create new instance of API class we initialize the CGP. (or your var name in the cgp.js).
 *
 * Blow are few examples of how we can use this API:
 *
 * Initialize the core and all the functionality of the application.
 * And the only thing we will bare to our client.
 *
 * options parameter is all the data you want to set in the initialize to your application.
 Core.GetEvent() is an singleton event handler for event driven patten.
 *
 *    initialize(options = {}) {
 *           new this.Initialize(options);
 *           return this;
 *    }
 *
 * You can add or remove the set functions because they are chainable methods.
 * The method return a promise with a property of request that
 * contain a reference to the current xhr.
 */
export class API {
    version = SDK_VERSION;

    serviceFactory: ServiceFactory = null;

    _isSdkReady: boolean;

    /**
     * @constructor
     * @param modelSettings
     */
    constructor(modelSettings) {
        this.serviceFactory = ServiceFactory.create();
        ConfigService.create().setDefaultConfig(modelSettings);
        this._isSdkReady = false;
        Event.on(SYSTEM_EVENTS.ON_INIT_COMPLETE, () => {
            this._isSdkReady = true;
        }, this);
    }

    /**
     * Used by automation
     * @return {boolean}
     */
    isSdkReady() {
        return this._isSdkReady;
    }

    /**
     *
     * @returns {string}
     */
    generateGUID() {
        return Device.generateGuid();
    }

    /**
     * @returns {API}
     * @public
     */
    initialize(userSettings, onInitCompleteCallback) {
        ConfigService.create().setUserConfig(userSettings);
        new Initialize(onInitCompleteCallback);
        return this;
    }

    getConfigs() {
        return ConfigService.create().getConfig();
    }

    /**
     * Logout from the application will remove access token and refresh token from local storage.
     * User will not be allowed anymore to preform an authentication role request to resource server until he authorize again.
     *
     * @usage:
     *      CGP.logout(); // Will remove access token from local storage and the user will not allowed to preform an authentication role request to resource server.
     *
     *
     * @public
     */
    logout() {
        return this.serviceFactory.oAuth2Service().logout();
    }

    runAutoLogin(autoLoginParams: IAutoLoginParams): Promise<void> {
        let sessionTimer: TimeSpan | undefined = undefined;
        if (Check.isNumber(autoLoginParams.sessionTimer)) {
            sessionTimer = TimeSpan.fromSeconds(autoLoginParams.sessionTimer);
        }
        return this.serviceFactory.oAuth2Service().runAutoLogin(autoLoginParams.token, sessionTimer, autoLoginParams.sourceProductPackage, autoLoginParams.brandId, autoLoginParams.sourceSubBrand, autoLoginParams.targetSubBrand);
    }


    /**
     * Open login form over overlay externally.
     * @example:
     *
     * // The open login form take these default values
     * var loginViewOptions = {
     *      marketingDataFn : 'getMarketingData(1234,abc,312312,null)'
     * }
     *
     * function onClose() {
     *    console.log('When clicking on the close overlay btn I will invoke!');
     * }
     *
     * function onSuccess() {
     *    console.log('When the login authentication will be successful I will invoke!');
     * }
     *
     * CGP.openLoginForm(loginViewOptions, onClose.bind(this), onSuccess.bind(this));
     *
     *
     *  @returns void
     */
    openLoginForm(marketingParams?: MarketingParams) {

        if (this.serviceFactory.oAuth2Service().isAuthorized()) {
            return Promise.resolve();
        }

        return this.serviceFactory.webLoginService().openLoginForm({
            marketingParams: marketingParams,
            onCloseCallback: () => {
                Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {category: 'Client_LoginPopup', action: 'Close'});
            }
        });
    }

    /**
     * Message popup CGP extra candy.
     *
     * @param {string} title - title of the message # Require
     * @param {string} text - text in the message
     * @param {MessageType} type - the type of the message
     * @param {MessagePriority} priority - the priority of the message
     * @param {MessageButton[]} buttons - array of string that represent button action
     */
    message({title, text, type, priority, buttons}) {
        //   MessageManager.create().addMessage(new MessageModel({title, text, type, priority, buttons}));
    }



    /**
     *
     * You also may to get reference to the overlay manager and fill it and create the display after the
     * Model is full.
     *
     * @usage:
     *  Full demonstration of the overlay options.
     *
     * @example 1:
     *      var el = document.createElement('DIV'); // Create arbitrarily DOM Element object.
     *      var over = CGP.openOverlay(el); // Call overlay function from cgp api and append the el in the function.
     *
     *  Close ability you the call.
     *      closeLastOverlay(); // will close the overlay and remove it from the DOM.
     *
     *
     * @param overlayOptions - Object {
     * el (object) - DOMElement Object that will be over the overlay,
     * priority (number) - The overlay priority level
     * id (number) - overlay id. If is not provided, the iverlay will be opened with incremented id from previous overlay. Will be deprecated later
     * isCloseBtnAllowed (bool) - determinate if overlay will be opened with close button. Default is true
     * }
     * @public
     */
    openOverlay(overlayOptions) {
        Event.fire(SYSTEM_EVENTS.OPEN_OVERLAY, overlayOptions);
    }


    /**
     * Close last overaly dialog appropriate to its priority level
     * @param priority
     * priority (number)  The overlay priority level
     */
    closeLastOverlay(priority) {
        Event.fire(SYSTEM_EVENTS.CLOSE_OVERLAY, {priority: priority});
    }

    getRegulationService() {
        return this.serviceFactory.regulationService();
    }

    /**
     * Close all overlay in the application.
     */
    closeAllOverlay() {
        Event.fire(SYSTEM_EVENTS.CLOSE_ALL_OVERLAY);
    }

    /**
     * Give access to device component.
     */
    device() {
        return Device;
    }

    getRegulationDateAndTimeFormat() {
        const skinService = this.serviceFactory.skinService();

        return {
            date: skinService.getDateFormat(),
            time: skinService.getTimeFormat(),
            dateTime: skinService.getDateTimeFormat(),
            dateTimeHistory: skinService.getDateTimeHistoryFormat()
        };
    }

    /**
     * Return list with id's of recently played games
     */
    getRecentlyGames() {
        return this.serviceFactory.recentlyPlayedService().getRecentlyPlayedList();
    }

    /**
     * Event Emitter give you the power to subscribe CGP system event handling.
     *
     * @usage:
     * // Simple use of CGP Event Subscriber we allowed to give the programmer the best way to integrate with CGP SDK JS.
     *
     * @example 1:
     * var oauthChangeEvent = CGP.onEvent({eventName: 'OAUTH_STATE_CHANGE'}); // now you will get notify when wallet change.
     *
     * @example 2:
     * // You can modify and add callback when the event been fired.
     * var oauthChangeEvent = CGP.onEvent({eventName: 'OAUTH_STATE_CHANGE', callback: function(){console.log('user wallet been changed')}})
     *
     * @example 3:
     * // We also giving the developer the relief of binding this to the callback context.. for Ecmascript 5 noobs
     * var oauthChangeEvent = CGP.onEvent({eventName: 'OAUTH_STATE_CHANGE', callback: function(){console.log('user wallet been changed')}, context: this)
     *
     * // Every variable subscribe come with off function that can be unsubscribe the event from listening.
     * oauthChangeEvent.off();
     *
     * // When you trying to subscribe to event that not exist or not allowed to be subscribe you will get undefined.
     * var oauthChangeEvent = CGP.onEvent('SOME_CUSTOM_EVENT_NOT_ALLOWED', function(){console.log('user wallet been changed')}, this)
     *
     * // The events we allowed to used are restricted due to CGP product design. for more information you can see full documentation in
     * // http://nocipedia/index.php?w=WEB&title=CGP:onEvent
     *
     *
     * @param eventOptions - Object {
     * eventName - Is the event name to subscribe to,
     * callback - Is the function that execute when the event fired. function() {alert('event fired')},
     * context - Is the context of the execution event callback.
     * }
     * @returns {*}
     */
    onEvent(eventOptions) {
        return Event.on(eventOptions.eventName, eventOptions.callback, eventOptions.context);
    }

    /**
     * Getter for the Username
     * if not authed, will return a false.
     *
     * @usage
     * var username = CGP.getUsername();
     *
     * @returns {String|Boolean}
     */
    getUsername() {
        if (this.isAuthorized()) {
            return this.serviceFactory.userService().getUsername();
        }

        return false;
    }

    getSessionId() {
        let oAuth2Service = this.serviceFactory.oAuth2Service();
        if (oAuth2Service.isAuthorized()) {
            return oAuth2Service.getToken().sessionId;
        } else {
            return null;
        }
    }

    /**
     * Is authorized giving the developer the power to know if the current user is authorized to the system or not.
     *
     * @usage
     * var isConnected = CGP.isAuthorized();
     * If the user is authorized to the system the output will be true else false.
     *
     * @example 1:
     * if (CGP.isAuthorized()) {
     *   console.log('Hi I'm loggedin');
     * }
     *
     * @returns {*|boolean}
     */
    isAuthorized() {
        return this.serviceFactory.oAuth2Service().isAuthorized();
    }

    isLoginFromRegistration() {
        return this.serviceFactory.oAuth2Service().isLoginFromRegistration();
    }


    isVIP() {
        return this.serviceFactory.oAuth2Service().isVIP();
    }


    getUserData() {
        return this.serviceFactory.oAuth2Service().getUserData();
    }


    getUserSegments() {
        return this.serviceFactory.integrationService().getUserSegments();
    }


    getSerial() {
        let marketingData: any;
        return this.serviceFactory.skinService().getSerialData(marketingData);
    }

    getHybrid() {
        return this.serviceFactory.hybridService();
    }

    isHybridEmbeddedGame(gameType: number): boolean {
        return this.serviceFactory.hybridService().isOnDemandHtmlGame(gameType);
    }

    openHybridLink(url: string) {
        return this.serviceFactory.hybridService().openExternalLink(url);
    }

    getUtils() {
        return _;
    }

    displayHybrid() {
        this.getHybrid().displayHybrid();
    }


    getProductPackage() {
        return this.serviceFactory.skinService().getProductPackageID();
    }

    getSkin() {
        return this.serviceFactory.skinService();
    }


    /**
     * open tab in new window - if Hybrid call call external link function
     */
    openInNewWindow(url, specs) {
        this.serviceFactory.windowService().openInNewWindow(url, specs);
    }

    /**
     * Get user token if exist.
     *
     * @usage
     * var token = CGP.getToken(); // if the user is authorized token will received it.
     *
     * @returns {Promise}
     */
    getToken() {
        return this.serviceFactory.oAuth2Service().getToken();
    }

    getPlatformToken() {
        return this.serviceFactory.userService().getPlatformToken();
    }

    getFirebaseToken() {
        return this.serviceFactory.userService().getFirebaseLoginToken();
    }

    getTrendingRecommendedGamesForPlayer(listTypeIds: number[]): Promise<{[key: number]: number[]}> {
        return this.serviceFactory.aiListService().getTrendingRecommendedGamesForPlayer(listTypeIds);
    }

    /**
     * Generates a platform token for autologin.
     *
     * @returns
     */
    getAutoLoginToken() {
        return this.serviceFactory.userService().renewLoginToken();
    }


    /**
     * Login a user using an AutoLogin/UserInfo token - provided usually by Platform.
     *
     * @returns
     */
    setAutoLoginToken(token) {
        Event.fire(SYSTEM_EVENTS.RUN_AUTOLOGIN, token);

        return this;
    }


    /**
     * Open Options
     * ReminderSettings, About,TouchId
     */
    openOptions(screenType, innerScreen) {
        const screen = OptionsComponentController.create().load(screenType);
        if (undefined !== innerScreen) {
            screen.setScreen(innerScreen);
        }

        screen.render();

        if (undefined !== innerScreen) {
            if (undefined !== this.getHybrid().getTouchIDFeaturer()) {
                this.getHybrid().getTouchIDFeaturer().setTouchIdComponentController(screen);
            }
        }
    }

    /**
     * get sub brand ID
     * @returns {*}
     */
    getSubBrandID() {
        return this.serviceFactory.skinService().getSubBrandID();
    }

    /**
     * get external brand callback url
     */
    getExternalBrandCallbackURL() {
        return this.serviceFactory.queryStringDetectorService().getExternalBrandCallbackURL();
    }

    /**
     * get external brand callback method
     */
    getExternalBrandCallbackURLMethod() {
        return this.serviceFactory.queryStringDetectorService().getExternalBrandCallbackURLMethod();
    }

    /**
     * get source sub brand name.
     */
    getSourceSubBrandName() {
        const sourceSubBrandID = this.serviceFactory.queryStringDetectorService().getSourceSubBrand();
        let sourceSubBrandName = "notFound";

        // We need it for back to. and also to recognize poker native.
        const pokerSubBrands = ['1', '114', '81', '45', '130', '106', '103'];
        const sportSubBrands = ['8', '115', '110', '116', '131', '128'];

        if (pokerSubBrands.includes(sourceSubBrandID)) {
            sourceSubBrandName = "poker";
        } else if (sportSubBrands.includes(sourceSubBrandID)) {
            sourceSubBrandName = "sport";
        }

        return sourceSubBrandName;
    }

    /**
     * get brand ID
     * @returns {*}
     */
    getBrandID() {
        return this.serviceFactory.skinService().getBrandID();
    }

    showInfo(txt) {

        let options = {
            hasImage: false,
            text: txt,
            closeButton: true,
            title: 'Info',
            buttons: [
                {name: 'Close', isClosable: true},
                {
                    name: 'MailTo:', isClosable: true, callback: () => {
                        this.getHybrid().openMail(encodeURIComponent(txt));
                    }
                }
            ]
        };
        this.openMessage(options);
    }

    openSafariTest(url) {
        this.getHybrid().openSafariTest(url);
    }

    navigateToSecondGameVebView(url) {
        Event.fire(SYSTEM_EVENTS.WEB_VIEW_NAVIGATE_GAME, url);
    }


    /**
     * Popup CGP messages in lightbox (overlay)
     *
     * @params
     * messageOptions {object} {
     * title {string}           message title text. It appears on the top of message dialog, but under icon if exists (read type and customIcon)
     * text {string}            message text. Can be every HTML markup. It appears under the title
     * type {string}            message type. There are strongly defined message types (see MESSAGE_TYPE const) [info, warning, error, success].
     *                          If one of them is passed and there is no customIcon, appropriate message icon will appear under the title.
     * customIcon {string}      url to custom icon. It overrides any message defined icon, that is to say, if you define message type, it will be ignored
     * priority {number}        message priority. Since the message opens on overlay, it defines the overlay priority. There are two priority types in CGP (HIGH and LOW).
     *                          default value for messages is PRIORITY_LEVEL.MESSAGE, so when your message will appear it will destroy all previous overlays and messages. If need to change this behaviour,
     *                          you should pass lower priority: PRIORITY_LEVEL.BASE, then your message will appear when the higher overlay destroys.
     *                          NOTE! If you pass priority and there is custom button in message (read button) that should close the message on click, be aware, you should pass priority
     *                          parameter in button onClick callback where you fire CLOSE_OVERLAY event
     *                          @Example
     *                          CGP.openMessage({priority: priorityValue}); //priorityValue =  PRIORITY_LEVEL.MESSAGE or PRIORITY_LEVEL.BASE (similar to what passed in message options)
     * closeButton {bool}       define if close X button will appear to close the message
     * buttons {array}          contains buttons on message dialog. Read button object definition in message_button.
     *                          By default, if the array is empty, message dialog render single default button with name 'OK' that close the dialog.
     *                          Each custom button by default closes message dialog. To prevent this behavior, isClosable button parameter will be define false explicitly. (see message_button).
     *                          @Example
     *                          [{name: 'btn1'}, {name: 'btn2', isClosable: false}]
     * buttonPosition {string}  define buttons position. Values: 'left', 'right', 'center'.
     *                          By default, in PC layout, button aligned to center, and in mobile to right side.
     *                          If buttonPosition is defined, it overrides this behaviour and valid both in PC and mobile
     *}
     */
    openMessage(messageOptions) {
        Event.fire(SYSTEM_EVENTS.MESSAGE_OPEN, messageOptions);
    }

    /**
     * Expose internal cgp events should be during development only!
     *
     * @returns {Event}
     */
    exposeEventInternal() {
        return Event;
    }

    structuredLoggingService(): IStructuredLoggingService {
        return this.serviceFactory.structuredLoggingService();
    }

    getCGPMaxOverlayZIndex(): number {
        return this.serviceFactory.overlayManagerService().getCGPMaxOverlayZIndex();
    }

    /**
     * Send GA analytic object
     *
     * analytic {object} contains GA properties (category, action, label, value)
     *
     *
     * @param analyticObject
     */
    sendAnalytics(analyticObject: IAnalyticsData) {
        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, analyticObject);
    }

    pushDataToDataLayer(data) {
        this.serviceFactory.analyticsService().pushDataToDataLayer(data);
    }

    getGoogleClientID() {
        return this.serviceFactory.analyticsService().getGoogleClientID();
    }

    /**
     * Add extra properties to GTA data layer
     * @param dataLayerObject
     */
    updateAnalyticsDataLayer(dataLayerObject) {
        Event.fire(SYSTEM_EVENTS.ANALYTIC_DATA_LAYER_UPDATE, dataLayerObject);
    }

    /**
     * Send specified event for trigger optimize experiment condition compare process
     */
    onSegmentationChanged() {
        Event.fire(SYSTEM_EVENTS.ANALYTICS_OPTIMIZE_TRIGGER);
    }

    /**
     * This function api gets a number type only in ` CENTS ` !.
     * Formatting cents due to user preference money format.
     * @param cents
     * @param roundIfZero if true and the decimal numbers are 0 value will return without the decimal number
     * @param options
     * @example #1: let jackpot = CGP.format$$$(1000000);
     *              console.log(jackpot) // $10,000.00
     * @example #2: let jackpot = CGP.format$$$(1000000, true);
     *              console.log(jackpot) // $10,000
     *
     * @example #3: let jackpot = CGP.format$$$(1000055, true);
     *              console.log(jackpot) // $10,000.55
     *
     * @returns {string}
     */
    format$$$(cents, roundIfZero = false) {
        if (!_.isNumber(cents)) {
            Logger.error('format$$$ invalid input => ', cents);
            return '';
        }

        return this.serviceFactory.currencyService().formatMoney(cents, {}, roundIfZero);
    }

    getCurrencyIso3(): string {
        return this.serviceFactory.currencyService().getCurrency();
    }


    kickSimulate(params) {
        this.serviceFactory.playerMessagesService().getMessageStrategy().KICKUpdateHandler(params.featureName, params.msgFields, params.fullTopic);
    }



    /**
     * Retrieves the games information like title from the backend
     * @param gameTypes - an array of game types
     * @param url - for using a URL on the fly (and not the service URI param)
     * @returns {Promise<T>} where T is a map where the key is the game type
     * Sample returned data:
     {
        130017: {gameType: 130017, title: 'Elm Street', background: 'someUrl'}
        130043: {gameType: 130043, title: 'Millionaire Genie', background: 'someUrl'}
     }
     */
    getGamesInfo(gameTypes) {
        return this.serviceFactory.gamesInformationService().getGamesInfo(gameTypes);
    }

    getGamesThemes(): Record<number, string> {
        return this.serviceFactory.gamesInformationService().themes;
    }

    getGamesVendors(): Record<number, string> {
        return this.serviceFactory.gamesInformationService().vendors;
    }

    getGamesCompanies(): Record<number, string> {
        return this.serviceFactory.gamesInformationService().companies;
    }

    /**
     * use this method only for history. this method will return also game info for restricted and not in layout games.
     * @param gameTypes
     */
    getGamesInfoForHistory(gameTypes) {
        return this.serviceFactory.gamesInformationService().getGamesInfoWithoutAnyFiltering(gameTypes);
    }

    /**
     * Get all game IDs as array
     * @param url - for using a URL on the fly (and not the service URI param)
     * @returns {*}
     */
    getAllGameTypes() {
        return this.serviceFactory.gamesInformationService().getAllGameTypes();
    }

    freePlayAdd(topic, fields) {
        return this.serviceFactory.playerMessagesService().getMessageStrategy().FPUpdateHandler(null, fields, topic);
    }


    applyRestrictions(restrictions) {
        this.serviceFactory.restrictionsService().applyRestrictions(restrictions);
    }


    /**
     * Retrieves the AI (Artificial Intelligence) game list from the backend
     * @returns {Promise<T>} 2 Arrays one with game types and the other with the AI game score for each type
     * @param maxGames - max games for return
     * @param filterOutRecentlyPlayedGames - if true we will filter out from the response the recently played games
     * @param numberOfRecentlyPlayedGameToFilterOut - numberOfRecentlyPlayedGameToFilterOut number of recently games that we need to filter out
     * Sample returned
     * AiGameListData = {
     * "aiGameTypesArray": ["130001", "130008", "130012", "130014", "130017", "130024", "130026", "130036"],
     * "aiEngine":  the engine/vendor name that return the AI list = for example 888
     * };
     */
    getAIList(maxGames, filterOutRecentlyPlayedGames, numberOfRecentlyPlayedGameToFilterOut = 0) {
        return this.serviceFactory.aiListService().getAIList(maxGames, filterOutRecentlyPlayedGames, numberOfRecentlyPlayedGameToFilterOut);
    }

    getAINewGamesList(maxGames, filterOutRecentlyPlayedGames, numberOfRecentlyPlayedGameToFilterOut = 0) {
        return this.serviceFactory.aiListService().getAINewGamesList(maxGames, filterOutRecentlyPlayedGames, numberOfRecentlyPlayedGameToFilterOut);
    }

    // will become obsolete, do not use anymore
    getAbTestingDataForFeature(featureName) {
        return this.serviceFactory.abTestingService().getAbTestingDataForFeature(featureName);
    }

    getAbTestingData() {
        return this.serviceFactory.abTestingService().getAbTestingData();
    }

    /**
     * @returns Promise<Boolean>
     */
    waitForAnonymousAbTestingData() {
        return this.serviceFactory.abTestingService().waitForAnonymousAbTestingData();
    }

    getAnonymousPlayerAbTestingDataForFeature(featureName: string, shouldDefaultToLocalStorageData: boolean): IAbTestingFeatureProperties {
        return this.serviceFactory.abTestingService().getAnonymousPlayerAbTestingDataForFeature(featureName, shouldDefaultToLocalStorageData);
    }

    /**
     * @returns Promise<Number>
     */
    countPlayerChallenges() {
        return this.serviceFactory.userService().countPlayerChallenges();
    }

    routeChanged(routeParams) {
        Event.fire(SYSTEM_EVENTS.ROUTE_CHANGED, routeParams);
    }

    getGamesDiagnosticMessages() {
        return this.serviceFactory.gamesInformationService().getDiagnosticMessages();
    }

    getLoginTime() {
        return this.serviceFactory.oAuth2Service().getLoginTime();
    }

    OMGSimulate(messages) {
        if (!messages) {
            return;
        }

        messages.forEach((message) => {
            this.serviceFactory.playerMessagesService().getMessageStrategy().OMGUpdateHandler('OMG', message);
        });
    }

    getGRSEnvironments() {
        return this.serviceFactory.gameService().getGRSEnvironments();
    }

    getCorrelatedGames(gameType, numberOfGames = 3) {
        return this.serviceFactory.gamesCorrelationService().getCorrelatedGames(gameType, numberOfGames);
    }

    simulateClockRequest(data) {
        this.serviceFactory.clockService().setServerTime("2019-01-23T15:27:03Z");
        this.serviceFactory.clockService().setRegulationOffset(-300);
    }

    getCurrentServerDate() {
        return this.serviceFactory.clockService().getCurrentServerDate();
    }

    formatToRegulationOffset(date: Date, dateFormattedToRegulation: Date): IDateFormattedToRegulationOffset {
        return this.serviceFactory.clockService().formatToRegulationOffset(date, dateFormattedToRegulation);
    }

    simulatePlayerMessages() {
        this.serviceFactory.playerMessagesService().getMessageStrategy()._getPlayerMessages();
    }

    isPlayerMessagesConnected(): boolean {
        return this.serviceFactory.playerMessagesService().isConnected;
    }

    createComponentRenderer(componentId) {
        return Directive.createComponentRenderer(componentId);
    }

    startLiveTableFeeds() {
        return this.serviceFactory.liveTablesService().start();
    }

    getTablesInfo() {
        return this.serviceFactory.liveTablesService().getTablesInfo();
    }

    stopLiveTableFeeds() {
        return this.serviceFactory.liveTablesService().stop();
    }

    testGamesQuestionnaire() {
        this.serviceFactory.gamesQuestionnaireService()._showOverlay();
    }

    getDailyDealCampaigns() {
        return this.serviceFactory.historyService().getDailyDealCampaigns();
    }

    getJackpotsById(): Record<number, IJackpotDataById> {
        return this.serviceFactory.jackpotFeedsService().getJackpotsById();
    }

    getJackpotsByGameType(): Record<number, IJackpotDataByGame> {
        return this.serviceFactory.jackpotFeedsService().getJackpotsByGameType();
    }

    getBankroll(balanceType: BalanceType, plainNumber: boolean = false) {
        return this.serviceFactory.walletService().getBankroll(balanceType, plainNumber);
    }


    getEnvironment() {
        return this.serviceFactory.structuredLoggingService().getEnvironment();
    }

    getCountryName() {
        return this.serviceFactory.countryService().countryName;
    }

    getCountryIso3() {
        return this.serviceFactory.countryService().getCountry();
    }

    getSupportedStates() {
        return this.serviceFactory.countryService().supportedStates;
    }

    getWrongLocationDetectionPath() {
        return this.serviceFactory.skinService().getWrongLocationDetectionPath();
    }

    clearLocalStorage() {
        localStorage.clear();
        Event.fire(SYSTEM_EVENTS.LOCAL_STORAGE_CHANGED);
    }

    private _onOrbitInitCompleteFired = false;
    onOrbitInitComplete() {
        if (!this._onOrbitInitCompleteFired) {
            this._onOrbitInitCompleteFired = true; // just in case somebody calls this function twice.
            Event.fire(SYSTEM_EVENTS.ON_ORBIT_INIT_COMPLETE);
        }

    }

    httpPost<TResponse>(url: string, requestData?: object): Promise<TResponse> {
        return this.serviceFactory.http2Service().post<TResponse>(url, requestData);
    }

    httpGet<TResponse>(url: string, requestData?: object): Promise<TResponse> {
        return this.serviceFactory.http2Service().get<TResponse>(url, requestData);
    }

    waitForAutologin() {
        return this.serviceFactory.oAuth2Service().waitForAutologin();
    }

    loadScript(options: LoadScriptOptions): Promise<void> {
        return this.serviceFactory.scriptLoaderService().loadScript(options);
    }

    getRefreshToken(): string {
        return this.serviceFactory.oAuth2Service().getRefreshToken();
    }

    get overlayZIndex(): SdkOverlayZIndex {
        return {
            OMG: PRIORITY_LEVEL_ZINDEX_MAPPER[PRIORITY_LEVEL.OMG],
            GAME_FRAME: PRIORITY_LEVEL_ZINDEX_MAPPER[PRIORITY_LEVEL.GAME_FRAME]
        };
    }

    isInAutologin(): boolean {
        return this.serviceFactory.oAuth2Service().isInAutologin();
    }

    fireDepositWidgetClosed() {
        Event.fire(SYSTEM_EVENTS.DEPOSIT_WIDGET_CLOSED);
    }


    /* Resumes the player's game after it was stopped, e.g. to display reality check */

    getGeoLocationInfo(): Promise<IGeoLocationInfo | null> {
        return this.serviceFactory.countryService().getGeoLocationInfo();
    }

    getDownloadAppLink() {
        return this.serviceFactory.skinService().getAppDownloadPageURL();
    }

    isDepositWidgetSupportedByHybrid(): boolean {
        return this.serviceFactory.hybridService().isDepositWidgetSupported();
    }

    promptPushNotificationPermissionRequest(): void {
        if (Device.hybrid.inCasino) {
            this.serviceFactory.hybridService().promptPermission();
        } else {
            return this.serviceFactory.webPushService().promptPermission();
        }
    }

    openPopUpOnSecondWebView(content, timeout): void {
        this.serviceFactory.hybridService().openPopUpOnSecondWebView(content, timeout);
    }

    closePopUpOnSecondWebView(): void {
        this.serviceFactory.hybridService().closePopUpOnSecondWebView();
    }

    getBurnoutAnimationZIndex() {
        return PRIORITY_LEVEL_ZINDEX_MAPPER[PRIORITY_LEVEL.SECONDARY_MESSAGE];
    }

    get hybrid() {
        return this.serviceFactory.hybridService();
    }
    get currentRegulation() {
        return this.serviceFactory.regulationService().getRegulation();
    }

    getCurrentBrowserTabId(): string {
        return this.serviceFactory.windowService().getCurrentBrowserTabId();
    }

    get hasOpenOverlays(): boolean {
        return this.serviceFactory.overlayManagerService().isActiveOverlayExists();
    }

    get gnwp() {
        return this.serviceFactory.gnwpService();
    }

    get scriptLoader(): IScriptLoaderService {
        return this.serviceFactory.scriptLoaderService();
    }

    stopGameTimeReminders(): void {
        OptionsComponentController.create().load('ReminderSettings').off();
    }

    extractTokenProperty(tokenProperty: string) {
        return this.serviceFactory.oAuth2Service().extractTokenProperty(tokenProperty);
    }
    updateTokenProperty(tokenProperty: string, value: NullableString) {
        return this.serviceFactory.oAuth2Service().updateTokenData(tokenProperty, value);
    }
    isLoginPopupEnabled(): boolean {
        return this.serviceFactory.regulationService().isLoginPopupEnabled();
    }

    getAccountData(): any {
        return this.serviceFactory.userService().getAccountData()
    }

    getTempAccountGnwpSource(): GNWP_SOURCES {
        return this.serviceFactory.regulationService().getTempAccountGnwpSource();
    }

    testSetInterval(intervalMS: number) {
        DOM.setInterval(() => {
            console.log("Testing setInterval on Android. Will remove");
        }, intervalMS);
    }

    testfromInterval(intervalMS: number) {
        this.serviceFactory.observableFactoryService().fromInterval(intervalMS, 'SESSION_TIMER_INCREMENT_INTERVAL')
            .forEach(() => {
                console.log("Testing fromInterval on Android. Will remove");
            });
    }

    getGameRestriction(gameType: number, gameGroupId: number, vendorId: number): IGameRestriction {
        return this.serviceFactory.restrictionsService().getGameRestriction(gameType, gameGroupId, vendorId);
    }
}
